import type { FC } from 'react'

import styled from 'styled-components'

interface Props {
  className?: string
  count?: number
}

const FilterCountComponent: FC<Props> = ({ className, count }) => {
  if (!count) return null

  return (
    <span className={className} data-test-id="search-filters-active-count">
      {count > 9 ? '9+' : count}
    </span>
  )
}

FilterCountComponent.displayName = 'FilterCount'

export const FilterCount = styled(FilterCountComponent)(({ theme }) => ({
  backgroundColor: theme.colors.secondary,
  borderRadius: theme.spacings.medium,
  color: theme.colors.white,
  display: 'inline-block',
  fontSize: theme.sizes.xxxs.fontSize,
  lineHeight: theme.sizes.xxxs.lineHeight,
  padding: 0,
  textAlign: 'center',
  width: theme.spacings.medium,
}))
